export const disabledItemOpacity = 0.5

export const groupItemCSSClassName = 'checkbox-radiogroup-group-item'
